import React from 'react';
import { Navigate } from 'react-router-dom';

import HomePage from '../components/reusable/HomePage/HomePage.js';
import About from '../view/pages/About/About.js';
import WhatWeDo from '../view/pages/WhatWeDo/WhatWeDo.js';
import Team from '../view/pages/Team/Team.js';
import Careers from '../view/pages/Careers/Careers.js';
import Contact from '../view/pages/Contact/Contact.js';
import NotFound from '../view/pages/NotFound/NotFound.js';

const getRoutes = () => [
  // ---- Primary pages ----
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <About /> },
  { path: '/what-we-do', element: <WhatWeDo /> },
  { path: '/team', element: <Team /> },
  { path: '/careers', element: <Careers /> },
  { path: '/contact', element: <Contact /> },

  // ---- Redirects from old URLs (preserve inbound links / SEO) ----
  { path: '/home', element: <Navigate to="/" replace /> },
  { path: '/service', element: <Navigate to="/what-we-do" replace /> },
  { path: '/for-facilities', element: <Navigate to="/what-we-do" replace /> },
  { path: '/facilities-page', element: <Navigate to="/what-we-do" replace /> },
  { path: '/facilities/acute-care', element: <Navigate to="/what-we-do" replace /> },
  { path: '/facilities/inpatient-rehab', element: <Navigate to="/what-we-do" replace /> },
  { path: '/facilities/skilled-nursing', element: <Navigate to="/what-we-do" replace /> },
  { path: '/acute-care-hospitals-page', element: <Navigate to="/what-we-do" replace /> },
  { path: '/inpatient-rehab-facilities-page', element: <Navigate to="/what-we-do" replace /> },
  { path: '/our-medical-director-model', element: <Navigate to="/what-we-do" replace /> },
  { path: '/outcomes', element: <Navigate to="/what-we-do" replace /> },
  { path: '/patients-and-families', element: <Navigate to="/what-we-do" replace /> },
  { path: '/meet-our-team', element: <Navigate to="/team" replace /> },
  { path: '/our-team', element: <Navigate to="/team" replace /> },
  { path: '/team/:slug', element: <Navigate to="/team" replace /> },
  { path: '/clinical-team', element: <Navigate to="/team" replace /> },
  { path: '/team-member-details', element: <Navigate to="/team" replace /> },
  { path: '/founder', element: <Navigate to="/team" replace /> },
  { path: '/leadership', element: <Navigate to="/team" replace /> },
  { path: '/business-strategic-ops', element: <Navigate to="/about" replace /> },
  { path: '/engineer-team', element: <Navigate to="/about" replace /> },
  { path: '/news', element: <Navigate to="/about" replace /> },
  { path: '/locations/:city', element: <Navigate to="/about" replace /> },
  { path: '/careers-and-culture', element: <Navigate to="/careers" replace /> },
  { path: '/join-our-team', element: <Navigate to="/careers" replace /> },
  { path: '/page-for-job-apply', element: <Navigate to="/careers" replace /> },
  { path: '/contact-us', element: <Navigate to="/contact" replace /> },

  // ---- 404 ----
  { path: '*', element: <NotFound /> },
];

export default getRoutes;
